/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FileMetaDataDto,
  GetMetaParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get file metadata filtered by category
 * @summary Get file metadata by category
 */
export const getMeta = (
    params: GetMetaParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FileMetaDataDto[]>(
      {url: `/api/frontend/files/meta`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMetaInfiniteQueryKey = (params?: GetMetaParams,) => {
    return [
    'infinite', `/api/frontend/files/meta`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetMetaQueryKey = (params?: GetMetaParams,) => {
    return [
    `/api/frontend/files/meta`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMetaInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMeta>>>, TError = unknown>(params: GetMetaParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetaInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeta>>> = ({ signal }) => getMeta(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMetaInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMeta>>>
export type GetMetaInfiniteQueryError = unknown


export function useGetMetaInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeta>>>, TError = unknown>(
 params: GetMetaParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeta>>,
          TError,
          Awaited<ReturnType<typeof getMeta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMetaInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeta>>>, TError = unknown>(
 params: GetMetaParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeta>>,
          TError,
          Awaited<ReturnType<typeof getMeta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMetaInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeta>>>, TError = unknown>(
 params: GetMetaParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get file metadata by category
 */

export function useGetMetaInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMeta>>>, TError = unknown>(
 params: GetMetaParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMetaInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMetaQueryOptions = <TData = Awaited<ReturnType<typeof getMeta>>, TError = unknown>(params: GetMetaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetaQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeta>>> = ({ signal }) => getMeta(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMetaQueryResult = NonNullable<Awaited<ReturnType<typeof getMeta>>>
export type GetMetaQueryError = unknown


export function useGetMeta<TData = Awaited<ReturnType<typeof getMeta>>, TError = unknown>(
 params: GetMetaParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeta>>,
          TError,
          Awaited<ReturnType<typeof getMeta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMeta<TData = Awaited<ReturnType<typeof getMeta>>, TError = unknown>(
 params: GetMetaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeta>>,
          TError,
          Awaited<ReturnType<typeof getMeta>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMeta<TData = Awaited<ReturnType<typeof getMeta>>, TError = unknown>(
 params: GetMetaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get file metadata by category
 */

export function useGetMeta<TData = Awaited<ReturnType<typeof getMeta>>, TError = unknown>(
 params: GetMetaParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeta>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMetaQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update file metadata information
 * @summary Update file metadata
 */
export const updateFileInfo = (
    fileMetaDataDto: FileMetaDataDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<FileMetaDataDto>(
      {url: `/api/frontend/files/meta`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fileMetaDataDto
    },
      options);
    }
  


export const getUpdateFileInfoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFileInfo>>, TError,{data: FileMetaDataDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFileInfo>>, TError,{data: FileMetaDataDto}, TContext> => {

const mutationKey = ['updateFileInfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFileInfo>>, {data: FileMetaDataDto}> = (props) => {
          const {data} = props ?? {};

          return  updateFileInfo(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFileInfoMutationResult = NonNullable<Awaited<ReturnType<typeof updateFileInfo>>>
    export type UpdateFileInfoMutationBody = FileMetaDataDto
    export type UpdateFileInfoMutationError = unknown

    /**
 * @summary Update file metadata
 */
export const useUpdateFileInfo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFileInfo>>, TError,{data: FileMetaDataDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFileInfo>>,
        TError,
        {data: FileMetaDataDto},
        TContext
      > => {

      const mutationOptions = getUpdateFileInfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get all available file metadata
 * @summary Get all file metadata
 */
export const getMetaAll = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FileMetaDataDto[]>(
      {url: `/api/frontend/files/meta/all`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMetaAllInfiniteQueryKey = () => {
    return [
    'infinite', `/api/frontend/files/meta/all`
    ] as const;
    }

export const getGetMetaAllQueryKey = () => {
    return [
    `/api/frontend/files/meta/all`
    ] as const;
    }

    
export const getGetMetaAllInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getMetaAll>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetaAllInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetaAll>>> = ({ signal }) => getMetaAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMetaAllInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getMetaAll>>>
export type GetMetaAllInfiniteQueryError = unknown


export function useGetMetaAllInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMetaAll>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaAll>>,
          TError,
          Awaited<ReturnType<typeof getMetaAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMetaAllInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMetaAll>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaAll>>,
          TError,
          Awaited<ReturnType<typeof getMetaAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMetaAllInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMetaAll>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all file metadata
 */

export function useGetMetaAllInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getMetaAll>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMetaAllInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetMetaAllQueryOptions = <TData = Awaited<ReturnType<typeof getMetaAll>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMetaAllQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMetaAll>>> = ({ signal }) => getMetaAll(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMetaAllQueryResult = NonNullable<Awaited<ReturnType<typeof getMetaAll>>>
export type GetMetaAllQueryError = unknown


export function useGetMetaAll<TData = Awaited<ReturnType<typeof getMetaAll>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaAll>>,
          TError,
          Awaited<ReturnType<typeof getMetaAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMetaAll<TData = Awaited<ReturnType<typeof getMetaAll>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMetaAll>>,
          TError,
          Awaited<ReturnType<typeof getMetaAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMetaAll<TData = Awaited<ReturnType<typeof getMetaAll>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all file metadata
 */

export function useGetMetaAll<TData = Awaited<ReturnType<typeof getMetaAll>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMetaAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMetaAllQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




